<template>
  <div class="main-content">
    <the-header :title="t('Edit application')">
      <template slot="buttons">
        &nbsp; <!-- Do not delete  -->
        <template v-if="showButtons">
          <client-side-download-button :application="this.application"/>
          <!--          <download-button :link="application.downloadLink" />-->
          <signed-document-upload
            v-if="this.application.patient.insurance.code !== null && this.application.patient.insurance.code === 25 && this.showSignedDocUpload"
            :application="this.application"/>
        </template>
      </template>
    </the-header>
    <div class="text-center" v-if="loading === true">
      <loading/>
    </div>
    <template v-if="loading === false">
      <standard-alert type="success"
        v-if="loading === false && application.status.slug !== 'concept' && application.submitDate === null"
        :text="t('Application was created. You can download the application or send it to insurance.')"
      />
      <standard-alert type="success"
        v-if="loading === false && application.status.slug !== 'concept' && application.submitDate !== null"
        :text="t('Application was created. You can download the application or check history of email communication.')"
      />
      <standard-alert type="danger"
        v-if="loading === false && application.protocol === null"
        :text="t('Application has no assigned protocol. Please pick one of the available below.')"
      />
      <standard-alert type="primary"
        v-if="loading === false && application.status.slug === 'concept'"
        :text="t('Fill form and finish application')"
      />
      <mail-list ref="mailList" :application-id="parseInt(application.id)"
        v-if="application.id !== undefined && application.patient.insurance.code === 25 && showButtons && application.submitDate !== null"
      />
      <div class="documents" v-if="application.protocol.panel.id === 3">
        <div class="doc-link">{{t('Documents to download')}}:</div>
        <a class="doc-link" v-for="document in this.documents" target="_blank" :href="document.documentLink">{{document.name}}</a>
      </div>
      <div>
        <protocol-body
          refs="applicationForm"
          v-if="null !== this.application.protocol"
          @saveData="saveData()"
          @validate="isValid()"
          @openPrescription="$refs.prescriptionModal.open()"
          @reload="initData"
          :accepted="accepted"
          :formData="application"
        />
        <prescription ref="prescriptionModal"
          :id="application.id"
          :prescribed="application.prescribed"
          :approved="application.approvedPackages"
          @added="initData()"
        />
        <titan-form
          v-if="null === application.protocol"
          :schema="protocolSchema"
          :model="application"
          @saveData="saveData()"
          :showActionButton="false"
        />
      </div>
    </template>
  </div>
</template>

<script>
  import TheHeader from '../../../admin/Layout/TheHeader'
  import Loading from '../../../core/Components/loading'

  import TitanForm from '../../../core/Form/Form'
  import ProtocolBody from './protocol-body'
  import Prescription from './prescription'

  import MailList from '../../../components/mail-list'
  import AcceptAction from '../../../core/AcceptAction'
  import StandardAlert from '../../../components/standard-alert'
  import DownloadButton from './download-button'
  import SendApplication from './send-application'
  import SignedDocumentUpload from './signed-document-upload'
  import ClientSideDownloadButton from './client-side-download-button'

  import { validateMultipleForms } from '../../../core/Libs/utils'
  import VueFormGenerator from 'vue-form-generator'

  export default {
    components: {
      TheHeader,
      Loading,

      TitanForm,
      ProtocolBody,
      Prescription,

      DownloadButton,
      ClientSideDownloadButton,
      SignedDocumentUpload,
      SendApplication,
      AcceptAction,
      StandardAlert,
      MailList,
    },
    created() {
      this.showSignedDocUpload = (document.location.host === 'dev-mendel.ceeor.com' || [21, 50, 60, 64, 8, 106, 198].includes(this.$parent.account.id))
    },
    mounted() {
      this.initData()
      this.loadDocuments()
    },
    computed: {
      protocol() {
        if (this.loading === false) {
          return this.application.protocol
        } else {
          return null
        }
      },
      showButtons() {
        return false === this.loading &&
          this.application !== undefined &&
          this.application.status !== null &&
          this.application.status.slug !== 'concept'
      },
      application() {
        return this.$store.state.applications.item
      },
      accepted() {
        return this.application.status !== undefined && 'accepted' === this.application.status.slug
      },
      account() {
        return this.$parent.account;
      }
    },
    watch: {
      '$route.params.id'() {
        this.initData()
      },
    },
    methods: {
      initData() {
        this.$store.commit('applications/setItem', {})
        this.loadApplications()
      },
      loadApplications() {
        this.loading = true
        return this.$store.dispatch('applications/get', this.$route.params.id).then(() => {
          this.loading = false
          if (null === this.application.protocol) {
            this.loadProtocolOptions()
          }
        }).catch(() => {
          this.loading = false
        })
      },
      isValid(showError = true) {
        const valid = validateMultipleForms([this.$refs.applicationForm])
        if (false === valid && true === showError) {
          this.$store.dispatch('alert/warning', this.t('Form has invalid data. Check it and try again.'))
        }
        return valid
      },
      saveData() {
        if (true === this.isValid(false)) {
          this.loading = true
          this.$store.dispatch('applications/update', this.$store.state.applications.item).then(() => {
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        }
      },
      loadProtocolOptions() {
        if (this.application.patient !== null) {
          this.$store.dispatch('protocols/listForPatient', this.application.patient.id).then(response => {
            let optionsList = []
            response.data.forEach(protocol => {
              optionsList.push({ value: protocol.id, name: protocol.shortName })
            })
            this.protocolSchema[0].fields[0].values = optionsList
            return response.data
          })
        }
      },
      loadDocuments() {
        let tags = [
          'exception_blitzima_castlem',
          'exception_blitzima_GVHD',
          'exception_blitzima_MCL_2',
          'exception_blitzima_NHL_do_1220',
          'exception_Bortezomib_MM',
          'exception_blitzima_castleman',
          'exception_blitzima_MCL_3',
          'exception_bortezomib_amyloidoza_20'
        ];
        this.$store.dispatch('documents/list',{'page':0}).then(response => {
          response.items.forEach(doc => {
            if(tags.includes(doc.tag)) {
              this.documents.push(doc)
            }
          });
        });
      },
    },
    data() {
      return {
        documents: [],
        protocolSchema: [
          {
            name: this.t('Select protocol'),
            type: 'main',
            fields: [
              {
                type: 'titanSelect',
                label: this.t('Protocol'),
                model: 'protocol',
                values: [],
                required: true,
                validator: VueFormGenerator.validators.required,
                onSelect: () => {
                  this.saveData()
                },
              },
            ],
          },
        ],
        panelId: 0,
        showForm: true,
        loading: true,
      }
    },
  }
</script>

<style lang="scss">
  .documents {
    padding:0.5rem;
    display: flex;
    flex-flow: wrap;
  }
  .doc-link {
    padding:0.2rem 0.5rem;
  }
  .second-button {
    margin-bottom: 20px;
  }

  .card-collapse {
    padding: 0;

    .titan-form {
      width: 100%;
    }

    .card {
      margin-bottom: 0;
      border-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/private/applications/manage-universal.vue